export var USER_TOKEN_FOUND = "USER_TOKEN_FOUND";
export var USER_LOGIN = "USER_LOGIN";
export var USER_LOGOUT = "USER_LOGOUT";
export var USER_TIMEZONE = "USER_TIMEZONE";
export var USER_DETAILS = "USER_DETAILS";
export var USER_DEFAULT_PAGE = "USER_DEFAULT_PAGE";
